<template>
  <div id="install-page">

    <div class="title">{{ $t("#TR-installation") }} <span></span></div>
    <div class="config-master">

      <div class="logo">
        <img src="../../assets/img/icon-mobile-100-w.png" class="img" alt="cat">
        <div class="text">rk-web-man</div>
      </div>
      <div v-if="settings && installStep" class="config-master-block">

        <div class="install-selector">
          <button type="button"
                  :disabled="lic.error"
                  class="btn install-selector-btn to-connction"
                  :class="installStep === 'connectionBlock' ? 'btn-success' : 'btn-outline-success'"
                  @click="changeTab('connectionBlock')">
            {{ $t("#TR-connection") }}
          </button>
          <button type="button"
                  class="btn install-selector-btn to-licence"
                  :class="{'btn-success': installStep === 'licenseBlock' && !lic.error,
                           'btn-outline-success': installStep !== 'licenseBlock'
                  }"
                  @click="changeTab('licenseBlock')">
            {{ $t("#TR-license") }}
          </button>
        </div>

        <div v-if="installStep === 'connectionBlock'" class="connection-setting">

          <div v-if="!connectionStatus && !checkParams()" class="small">
            <b-alert show class="col-sm-12 px-3 py-1" variant="danger" fade>
              <b>{{ $t("#TR-fill-all-fields") }}</b>
            </b-alert>
          </div>
          <div v-if="!connectionStatus && !connectionError && checkParams()" class="small">
            <b-alert show class="col-sm-12 px-3 py-1" variant="warning" fade>
              <b>{{ $t("#TR-check_connection") }}</b>
            </b-alert>
          </div>
          <div v-if="connectionStatus && checkParams()">
            <b-alert show class="col-sm-12 px-3 py-1" variant="success" fade>
              {{ $t("#TR-connection-data-is-correct") }}:  {{ $t("#TR-click") }} <b>"{{ $t("#TR-save") }}"</b>
            </b-alert>
          </div>
          <div v-if="connectionError" class="small" @click="connectionError = false">
            <b-alert show class="col-sm-12  px-3 py-1" variant="danger" fade>
              <span class="font-weight-bolder">{{ $t("#TR-connection-error") }}:</span>
              {{ connectionError.desc }}
            </b-alert>
          </div>

          <div class="ttl text-uppercase">{{ $t("#TR-connection-settings") }}</div>
          <div class="row mb-3">
            <div class="col-sm-12 col-md-6">
              <label>#TR-host:</label>
              <b-form-input v-model="settings.sqlConnection.raw.host"
                            @change="changeForm">
              </b-form-input>
            </div>
            <div class="col-sm-12 col-md-6">
              <label>{{ $t("#TR-port") }}:</label>
              <b-form-input v-model="settings.sqlConnection.raw.port"
                            @change="changeForm">
              </b-form-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <label> {{ $t("#TR-command-timeout") }} ({{ $t("#TR-sec") }}):</label>
              <b-form-input v-model="settings.sqlConnection.raw.commandTimeoutSecs"
                            @change="changeForm">
              </b-form-input>
            </div>

            <div class="col-sm-12 col-md-6">
              <label>{{ $t("#TR-connection-timeout") }} ({{ $t("#TR-sec") }}):</label>
              <b-form-input v-model="settings.sqlConnection.raw.connectionTimeoutSecs"
                            @change="changeForm">
              </b-form-input>
            </div>
          </div>
          <div class="ttl mt-3 text-uppercase">{{ $t("#TR-database-settings") }}</div>
          <div class="row mb-3">
            <div class="col-sm-12 col-md-6">
              <label>{{ $t("#TR-DB-name") }}:</label>
              <b-form-input v-model="settings.sqlConnection.raw.dbName"
                            @change="changeForm">
              </b-form-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <label>{{ $t("#TR-user-name") }}:</label>
              <b-form-input v-model="settings.sqlConnection.raw.userName"
                            trim
                            @change="changeForm">
              </b-form-input>
            </div>
            <div class="col-sm-12 col-md-6">
              <label>{{ $t("#TR-password") }}:</label>
              <b-form-input v-model="settings.sqlConnection.raw.password"
                            type="password"
                            trim
                            @change="changeForm">
              </b-form-input>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-6">
              <b-button class="float-left  w-100"
                        variant="success"
                        type="button"
                        :disabled="!checkParams()"
                        @click="testConnect()">
                <span class="mdi mdi-lan-connect"></span> {{ $t("#TR-test") }} <span class="d-none d-md-inline">{{ $t("#TR-connection") }}</span>
              </b-button>
            </div>
            <div class="col-6">
              <b-button class="float-right w-100"
                        variant="success"
                        type="button"
                        :disabled="!connectionStatus || !checkParams()"
                        @click="saveSetting()">
                <span class="mdi mdi-lan-connect"></span>{{ $t("#TR-save") }}
              </b-button>
            </div>
          </div>
        </div>

        <div v-if="installStep === 'licenseBlock'" class="license-setting">

          <div v-if="lic.info" class="row small">
            <div class="col-6 text-muted text-right">{{ $t("#TR-owner") }}:</div>
            <div class="col-6 text-dark"><b>{{ lic.info.owner }}</b></div>
          </div>
          <div v-if="lic.info" class="row small mb-3 ">
            <div class="col-6 text-muted text-right">{{ $t("#TR-expiration-date") }}:</div>
            <div class="col-6 text-dark"><b>{{ lic.info.endDts }}</b></div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-12">
              <label>{{ $t("#TR-hardware-code") }}:</label>
              <b-input-group>
                <b-form-input v-model="lic.hardware" class="d-none d-sm-block" readonly></b-form-input>
                <b-form-textarea v-model="lic.hardware"
                                 class="d-block d-sm-none"
                                 readonly
                                 placeholder="Enter activation code.."
                                 size="sm"
                                 trim>
                </b-form-textarea>
                <b-input-group-append>
                  <b-button variant="success" @click="copyHWID"><span class="mdi mdi-clipboard-text"></span>{{ $t("#TR-copy") }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-12">
              <label>{{ $t("#TR-license-code") }}:</label>
              <b-form-textarea
                id="textarea"
                v-model="lic.code"
                placeholder="Enter activation code.."
                rows="5"
                max-rows="5">
              </b-form-textarea>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 offset-md-3 col-md-6 text-center">
              <button class="btn btn-success" @click="activateLicCode">
                <span class="mdi mdi-check align-middle mr-1"></span>{{ $t("#TR-activate") }} <span class="d-none d-sm-inline">{{ $t("#TR-license-code") }}</span>
              </button>
            </div>
          </div>

        </div>

      </div>

    </div> <!-- END MASTER-->
    <notifications group="NotifyMessage"
                   classes="main-notify">
    </notifications>
  </div>
</template>

<script>
  import { ApiSys } from '@/services/api';
  import { Settings } from '@/modules/settings';
  import MSG from '@/services/notify';


  export default {
    name: 'Install',
    data() {
      return {
        action: this.$route.params.a,
        lic: {
          generate: false,
          hardware: null,
          code: null,
          info: null,
          error: false
        },
        settings: null,
        connectionError: false,
        installStep: null,
        connectionStatus: false
      };
    },

    async created() {
      this.settings = await Settings.get(this);
      // await this.testConnect();
      await this.getLicInfo();
      this.getHWID();
      this.installStep = this.action === 'license' ? 'licenseBlock' : 'connectionBlock';
    },

    methods: {

      changeTab: function (tab) {
        if (this.lic.error) {
          return;
        }
        this.installStep = tab;
      },

      getHWID: async function () {
        const result = await ApiSys.getLicenseHWID();

        if (!result.error) {
          this.lic.hardware = result.data;
        } else {
          MSG.error(result.error, this);
        }
      },

      getLicInfo: async function () {
        this.lic.error = false;
        const result = await ApiSys.checkLicense();
        if (!result.error) {
          this.lic.info = result.data;
        } else {
          const errorArr = [
            'ERR_LICENSE_INVALID',
            'ERR_LICENSE_EXPIRED',
            'ERR_LICENSE_NOT_FOUND'
          ];
          if (errorArr.includes(result.error.code)) {
            this.lic.error = true;
          } else {
            MSG.error(result.error, this);
          }
        }
      },

      checkParams() {
        const options = this.settings.sqlConnection.raw;
        const res = !!(options.host && options.port && options.dbName && options.userName && options.password && options.connectionTimeoutSecs && options.commandTimeoutSecs);
        if (!res) {
          this.connectionStatus = false;
        }

        return res;
      },

      testConnect: async function () {

        this.connectionError = false;
        this.connectionStatus = false;

        if (!this.checkParams()) {
          return;
        }

        const result = await Settings.testSqlConnect(this.settings.sqlConnection.raw);
        setTimeout(() => {
          if (result.error) {
            this.connectionError = result.error;
          } else {
            this.connectionError = false;
            this.connectionStatus = true;
            MSG.clear(this);
            // MSG.success('Connection was successful', this);
          }
        }, 1000);
      },

      changeForm() {
        this.connectionError = false;
        this.connectionStatus = false;
      },

      saveSetting: async function () {
        const result = await Settings.save(this.settings);

        if (result.error) {
          MSG.error(result.error, this);
        } else {
          localStorage.token = '';
          this.$store.commit('clearToken');

          // document.location = ('/');
          // location.reload();

          this.$router.push({ name: 'auth' }).catch(() => {});
        }
      },

      activateLicCode: async function () {
        if (!this.lic.code) {
          MSG.error('Enter activation code', this);

          return;
        }

        const result = await ApiSys.licenseGenerate({ licenseText: this.lic.code });

        if (result.error) {
          MSG.error(result.error, this);
        } else {
          document.location = ('/');
          // location.reload();
          // await this.getLicInfo();
          // this.lic.generate = false;
        }
      },


      test: function () {
        // document.location = ('/');
        this.$router.push({ name: 'auth' }).catch(() => {
        });
      },

      copyHWID: function () {
        navigator.clipboard.writeText(this.lic.hardware).then(() => {
          MSG.success('Copied!', this);
        }, function (err) {
          console.log(err);
        });
      }
    }
  };
</script>

<style lang="stylus" scoped>

    #install-page {
        margin: 0 auto
        padding: 3px
        min-width: 100%
        height: 100%
        position: absolute
        top: 0
        left: 0
        display: flex
        flex-direction: column
        padding-top: 10%
        align-items: center
        background: #f9f9f9

        .title {
            color: c-accent
            font-size: 32px
            margin-bottom: 10px
            font-weight: 100

            span {
                color: #000000
            }
        }

        .config-master {
            min-width: 320px
            max-width: 600px
            width: 100%
            background: #ffffff
            box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.15)
            border-radius: 10px
            display: flex


            .logo {
                width: 80px
                background: c-accent
                padding: 10px 0
                border-top-left-radius: 10px
                border-bottom-left-radius: 10px

                img {
                    width: 70px
                    height: auto
                    display: block
                    margin-bottom: 30px
                }

                .text {
                    color: #fff;
                    font-size: 34px
                    width: 26px
                    margin: 0 auto
                    text-align: center
                    word-wrap: break-word
                    text-transform: uppercase
                    line-height: 30px
                    font-family: Consolas, Monaco, monospace
                }
            }
            .config-master-block {
                flex: auto

                .connection-setting {
                    padding: 20px
                }


                .license-setting {
                    padding: 20px
                }

                .ttl {
                    font-size: 14px;
                    border-bottom: 1px solid #dfdfdf;
                    margin-bottom: 8px;
                    padding-bottom: 5px;
                    color: c-accent;
                    line-height: 13px;
                }


                .install-selector {
                    height: 40px
                    width: 100%
                    display: flex

                    .btn {
                        width: 50%
                    }
                }

            }
        }
    }


</style>
